@if (showModal()) {
<div class="byoid-provisioning-modal">
  <div class="modal-content">
    <div class="modal-flex-row">
      <div class="icon-col">
        <span class="icon-circle"><span class="icon-exclamation">!</span></span>
      </div>
      <div class="content-col">
        <div class="headline">Account Setup Started</div>
        <div class="subtext">Your account is being created. Please sign in again shortly to continue.</div>
      </div>
    </div>
    <div class="button-row">
      <button class="modal-action-btn" (click)="onConfirm()">OK</button>
    </div>
  </div>
</div>
}
